// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { BulkInvoicesRows } from '../../../assets/data/candidatesData';
// import { mapTableRows } from '../../../utils';
// import Failed from './Invoices/Viewbatchlist/Failed';
// import CreatedInvoives from './Invoices/Viewbatchlist/CreatedInvoives';
// import { Button, Divider, FormFieldSet, NewTable, PageHeader, PageTab, PageTitle, Tag, useFormHandler } from '../../../components';
// import ProcessingPage from './Invoices/Viewbatchlist/ProcessingPage';

// const BulkInvoices = () => {
//   const navigate = useNavigate();
//   const handleBack = () => navigate("/invoices");

//   const [activeTabIndex, setActiveTabIndex] = useState(0);
//   const [showBatchListTabs, setShowBatchListTabs] = useState(false);

//   const { formData, errors, handleChange } = useFormHandler();

//   const BulkInvoicesColumns = [
//     { key: "InvoicePreview", label: "Invoice Preview" },
//     { key: "Employee", label: "Employee" },
//     { key: "JobTitle", label: "Job Title" },
//     { key: "Client", label: "Client" },
//     { key: "InvoiceFrequency", label: "Invoice Frequency" },
//     { key: "InvoicePeriod", label: "Invoice Period" },
//     { key: "TimesheetDates", label: "Timesheet Dates" },
//     { key: "TotalHours", label: "Total Hours" },
//   ];

//   const tablerowData = BulkInvoicesRows;
//   const mappedRows = mapTableRows(tablerowData, BulkInvoicesColumns);

//   const ViewBatchTabs = [
//     {
//       title: "Processing",
//       page: <ProcessingPage />,
//       type: "main",
//     },
//     {
//       title: "Created Invoices",
//       page: <CreatedInvoives />,
//       type: "main",
//     },
//     {
//       title: "Failed",
//       page: <Failed />,
//       type: "main",
//     },
//     {
//       title: "Back",
//       type: "sub",
//       icon: "arrow_left_alt",
//       action: () => setShowBatchListTabs(false),
//     },
//   ];

//   const handleTabChange = (index) => {
//     setActiveTabIndex(index);
//   };

//   return (
//     <div>
//       {!showBatchListTabs ? (
//         <>
//           <PageHeader
//             Section={
//               <div className="flex gap-3">
//                 <PageTitle title={"Create bulk Invoices"} tag="p" size={"sm"} />
//                 <Tag
//                   title="Tektree"
//                   variant="outlined"
//                   className=" !text-neutrals !py-1.5"
//                 />
//               </div>
//             }
//             RightSection={
//               <div className="flex gap-3">
//                 <Button
//                   size="sm"
//                   title={"Back"}
//                   icon={"arrow_left_alt"}
//                   onClick={handleBack}
//                 />
//                 <Button
//                   size="sm"
//                   title={"View Batch List"}
//                   onClick={() => setShowBatchListTabs(true)}
//                 />
//               </div>
//             }
//           />
//           <div className="grid grid-cols-3 max-w-7xl gap-x-6 gap-y-8 mt-3">
//             <FormFieldSet
//               type="select"
//               title={"Select Client"}
//               placeholder="VDart Inc | CLN-001"
//               value={formData.selectClient}
//               onChange={(value) => handleChange("selectClient", value)}
//               error={errors.selectClient}
//             />
//             <FormFieldSet
//               type="datepicker"
//               title={"Payment Received Date"}
//               placeholder="04/05/2025"
//               value={formData.paymentReceivedDate}
//               onChange={(value) => handleChange("paymentReceivedDate", value)}
//               error={errors.paymentReceivedDate}
//             />
//             <div></div>
//             <FormFieldSet
//               type="datepicker"
//               title={"Payment Received Date"}
//               placeholder="04/05/2025"
//               value={formData.paymentReceivedDate}
//               onChange={(value) => handleChange("paymentReceivedDate", value)}
//               error={errors.paymentReceivedDate}
//             />
//             <FormFieldSet
//               type="datepicker"
//               title={"Payment Received Date"}
//               placeholder="04/05/2025"
//               value={formData.paymentReceivedDate}
//               onChange={(value) => handleChange("paymentReceivedDate", value)}
//               error={errors.paymentReceivedDate}
//             />
//             <FormFieldSet
//               type="datepicker"
//               title={"Payment Received Date"}
//               placeholder="04/05/2025"
//               value={formData.paymentReceivedDate}
//               onChange={(value) => handleChange("paymentReceivedDate", value)}
//               error={errors.paymentReceivedDate}
//             />
//           </div>

//           <div className="flex justify-end gap-4 mr-5 mb-2">
//             <Button title={"Reset Filters"} variant="outlined" />
//             <Button title={"Search"} />
//           </div>
//           <Divider />
//           <NewTab
//             columns={BulkInvoicesColumns}
//             rows={mappedRows}
//             hideToolBar
//           />
//         </>
//       ) : (
//         <NewTab
//           tabs={ViewBatchTabs}
//           color="black"
//           variant="text"
//           activeVariant="text"
//           onTabChange={handleTabChange}
//         />
//       )}
//     </div>
//   );
// };

// export default BulkInvoices;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BulkInvoicesRows } from "../../../assets/data/candidatesData";
import { mapTableRows } from "../../../utils";

import {
  Button,
  Divider,
  FormFieldSet,
  NewTable,
  PageHeader,
  PageTitle,
  Tag,
  useFormHandler,
} from "../../../components";
import {
  BulkInvoicesClientOptions,
  BulkInvoicesEmployeeOptions,
  BulkInvoicesLineItemsOptions,
  BulkInvoicesPeriodOptions,
  invoiceFrequencyTypeOptions,
} from "../../../assets/data/projectData";
import ViewBathList from "./BlukInvoices/ViewBathList";

const BulkInvoices = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/invoices");
  const [showBatchListTabs, setShowBatchListTabs] = useState(false);
  const { formData, errors, handleChange } = useFormHandler({
    selectFrequency: "",
    selectPeriod: "",
    selectClient: "",
    selectEmployee: "",
    lineItems: "",
  });

  const BulkInvoicesColumns = [
    { key: "InvoicePreview", label: "Invoice Preview" },
    { key: "Employee", label: "Employee" },
    { key: "JobTitle", label: "Job Title" },
    { key: "Client", label: "Client" },
    { key: "InvoiceFrequency", label: "Invoice Frequency" },
    { key: "InvoicePeriod", label: "Invoice Period" },
    { key: "TimesheetDates", label: "Timesheet Dates" },
    { key: "TotalHours", label: "Total Hours" },
  ];

  const tablerowData = BulkInvoicesRows;
  const mappedRows = mapTableRows(tablerowData, BulkInvoicesColumns);
  return (
    <div>
      {!showBatchListTabs ? (
        <>
          <PageHeader
            Section={
              <div className="flex gap-3">
                <PageTitle title={"Create bulk Invoices"} tag="p" size={"sm"} />
                <Tag
                  title="Tektree"
                  variant="outlined"
                  className=" !text-neutrals !py-1.5"
                />
              </div>
            }
            RightSection={
              <div className="flex gap-3">
                <Button
                  size="sm"
                  title={"Back"}
                  icon={"arrow_left_alt"}
                  onClick={handleBack}
                />
                <Button
                  size="sm"
                  title={"View Batch List"}
                  onClick={() => setShowBatchListTabs(true)}
                />
              </div>
            }
          />
          <div className="grid grid-cols-3 max-w-7xl gap-x-6 gap-y-8 mt-3">
            <FormFieldSet
              type="select"
              title={"Select Frequency"}
              placeholder="Select Frequency"
              value={formData.selectFrequency}
              onChange={(value) => handleChange("selectFrequency", value)}
              error={errors.selectFrequency}
              options={invoiceFrequencyTypeOptions}
            />
            <FormFieldSet
              type="select"
              title={"Select Period"}
              placeholder="Select Period"
              value={formData.selectPeriod}
              onChange={(value) => handleChange("selectPeriod", value)}
              error={errors.selectPeriod}
              options={BulkInvoicesPeriodOptions}
            />
            <div></div>
            <FormFieldSet
              type="select"
              title={"Select Client"}
              placeholder="Select Client"
              value={formData.selectClient}
              onChange={(value) => handleChange("selectClient", value)}
              error={errors.selectClient}
              options={BulkInvoicesClientOptions}
            />
            <FormFieldSet
              type="select"
              title={"Select Employee"}
              placeholder="Select Employee "
              value={formData.selectEmployee}
              onChange={(value) => handleChange("selectEmployee", value)}
              error={errors.selectEmployee}
              options={BulkInvoicesEmployeeOptions}
            />
            <FormFieldSet
              type="select"
              title={"Line Items"}
              placeholder="Select Line Items"
              value={formData.lineItems}
              onChange={(value) => handleChange("lineItems", value)}
              error={errors.lineItems}
              options={BulkInvoicesLineItemsOptions}
            />
          </div>

          <div className="flex justify-end gap-4 mr-5 mb-2">
            <Button title={"Reset Filters"} variant="outlined" />
            <Button title={"Search"} />
          </div>
          <Divider className="my-6" />
          <NewTable
            columns={BulkInvoicesColumns}
            rows={mappedRows}
            hideToolBar
          />
        </>
      ) : (
        <ViewBathList onBack={() => setShowBatchListTabs(false)} />
      )}
    </div>
  );
};

export default BulkInvoices;
